export const TutorialUIList = [
  { value: 'Dynamic', label: 'DynamicText' },
  { value: 'YouTube', label: 'YouTube' },
  { value: 'Image', label: 'Image' },
  { value: 'AccordionImage', label: 'AccordionImage' },
  { value: 'TextBanner', label: 'TextBanner' },
  { value: 'TwoButtonLink', label: 'TwoButtonLink' },
  { value: 'AccordionDynamic', label: 'AccordionDynamic' },
];
